import Image from 'next/image';

type WistiaPlaceholderProps = {
  id: string;
  name?: string;
};

export const WistiaPlaceholder = ({
  id,
  name = '',
}: WistiaPlaceholderProps) => {
  return (
    <div className='wistia_swatch relative overflow-hidden w-full h-full'>
      <Image
        fill
        quality='65'
        src={`https://fast.wistia.com/embed/medias/${id}/swatch`}
        className='h-full w-full object-contain blur-sm'
        aria-hidden='true'
        alt={name}
      />
    </div>
  );
};
